export const PAYOUT_BANK_DATA = "PAYOUT_BANK_DATA";
export const PAYOUT_BANK_HIDE_ERROR = "PAYOUT_BANK_HIDE_ERROR";
export const PAYOUT_BANK_ERROR = "PAYOUT_BANK_ERROR";
